module.exports = __webpack_public_path__ + "images/bannerES-04e17469b4db60826cc5d1536a741e8e.png";